import { mooberApiV1 as apiV1, mooberApiV2 as apiV2 } from '@/api/mooberApi';

const getDashboard = ({ companyId }) => apiV1.get(`companyDashboard/${companyId}/loadSettlements`);
const getDashboardV2 = ({ companyId }) => apiV2.get(`companyDashboard/${companyId}/transactions`);
const acknowledgePayment = ({ settlementId, paymentInfo }) => apiV1.post(`loadSettlement/${settlementId}/acknowledgePayment`, paymentInfo);
const applyPayment = ({ settlementId, paymentInfo }) => apiV1.post(`loadSettlement/${settlementId}/payment`, paymentInfo);
const attachInvoice = ({ settlementId, paymentInfo }) => apiV1.post(`loadSettlement/${settlementId}/invoice`, paymentInfo);
const getTimeline = settlementId => apiV1.get(`timeline/loadSettlement/${settlementId}`);
const sendMessage = ({ settlementId, messageRequest }) => apiV1.post(`timeline/loadSettlement/${settlementId}`, messageRequest);
const uploadSettlementFile = ({ settlementId, message, base64s }) =>
  apiV1.post(`timeline/loadSettlement/${settlementId}/file`, {
    message,
    base64EncodedData: base64s[0][0],
    sent: new Date().toISOString(),
  });
const update = ({ settlementId, body }) => apiV1.post(`loadSettlement/${settlementId}`, body);
const cancelTransaction = transactionId => apiV2.delete(`transaction/${transactionId}`);
const getTransaction = transactionId => apiV2.get(`transaction/${transactionId}`);

export default {
  getDashboard,
  getDashboardV2,
  acknowledgePayment,
  applyPayment,
  getTimeline,
  attachInvoice,
  sendMessage,
  uploadSettlementFile,
  update,
  cancelTransaction,
  getTransaction,
};



// WEBPACK FOOTER //
// ./src/api/settlements.js